import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const scrollToForm = () => {
    document.getElementById('qualify-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 bg-charcoal relative overflow-hidden" data-id="element-28">
      {/* Radial gold gradient glow */}
      <div className="absolute inset-0 bg-gradient-radial from-gold-primary/10 via-transparent to-transparent opacity-30" data-id="element-29" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-30">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-4xl md:text-6xl mb-6 leading-tight" data-id="element-31">
          Your Competitors Are Getting Funded. Are You?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-lg md:text-xl text-white font-bold mb-10" data-id="element-32">
          Don't let lack of capital slow your business down another week.
        </motion.p>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} animate={{
        boxShadow: ['0 0 20px rgba(240,185,11,0.3)', '0 0 40px rgba(240,185,11,0.6)', '0 0 20px rgba(240,185,11,0.3)']
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4,
        boxShadow: {
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }
      }} onClick={scrollToForm} className="bg-gold-primary text-black font-bold text-xl md:text-2xl px-12 md:px-16 py-5 md:py-6 rounded-lg hover:bg-gold-accent transition-all duration-300 mb-4" data-id="element-33">
          Check If You Qualify in 60 Seconds →
        </motion.button>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-gold-primary font-bold text-lg" data-id="element-34">
          ⚡ Average funding time: 36 hours
        </motion.div>
      </div>
    </section>;
}